module.exports = __webpack_public_path__ + "static/media/alien_operator_success.c2bb5d1f.png";